/**
 * Маска українського номера телефону: +380 XX XXX XX XX
 *
 * Працює на всіх полях типу `tel` (форми бронювання столика, контактів тощо).
 * Слухач на document — тому підхоплює й поля, які CF7 домальовує динамічно.
 *
 * Логіка: тримаємо у полі ТІЛЬКИ цифри, а форматування (пробіли, "+380")
 * домальовуємо при кожному вводі. Так користувач не може зламати маску —
 * ані вставкою з буфера, ані стиранням із середини.
 */

const PREFIX = '+380';
const MAX_DIGITS = 9; // після 380 — рівно 9 цифр українського номера

/**
 * Форматує сирий ввід у "+380 XX XXX XX XX".
 */
function format(raw) {
	// Лишаємо самі цифри й прибираємо код країни (380), якщо його вставили.
	let digits = raw.replace(/\D/g, '');

	if (digits.startsWith('380')) {
		digits = digits.slice(3);
	} else if (digits.startsWith('0')) {
		// Людина вводить "067…" — нуль зайвий, бо він уже є в +380.
		digits = digits.slice(1);
	}

	digits = digits.slice(0, MAX_DIGITS);

	if (!digits) return '';

	// XX XXX XX XX
	const groups = [
		digits.slice(0, 2),
		digits.slice(2, 5),
		digits.slice(5, 7),
		digits.slice(7, 9),
	].filter(Boolean);

	return `${PREFIX} ${groups.join(' ')}`;
}

export default function phoneMask() {
	const isPhone = (el) => el instanceof HTMLInputElement && el.type === 'tel';

	document.addEventListener('input', (e) => {
		if (!isPhone(e.target)) return;

		const input = e.target;
		const before = input.value;
		const formatted = format(before);

		if (formatted === before) return;

		input.value = formatted;
		// Курсор — завжди в кінець: спроби зберегти позицію всередині маски
		// дають більше багів, ніж користі (людина все одно друкує з кінця).
		input.setSelectionRange(formatted.length, formatted.length);
	});

	// Клік у порожнє поле — одразу підставляємо префікс, щоб не гадати формат.
	document.addEventListener('focusin', (e) => {
		if (!isPhone(e.target)) return;
		if (e.target.value === '') {
			e.target.value = `${PREFIX} `;
		}
	});

	// Пішли з поля, нічого не ввівши — прибираємо самотній префікс,
	// інакше форма вважатиме поле заповненим.
	document.addEventListener('focusout', (e) => {
		if (!isPhone(e.target)) return;
		if (e.target.value.trim() === PREFIX) {
			e.target.value = '';
		}
	});
}
